import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = `${import.meta.env.VITE_API_URL}/api/waitlist`;

/**
 * Fetch all waitlist entries with pagination and search
 */
export const fetchWaitlist = createAsyncThunk(
  "waitlist/fetchAll",
  async ({ page = 1, limit = 10, search, date, startDate, endDate }, { rejectWithValue }) => {
    try {
      let url = `${API_URL}?page=${page}&limit=${limit}`;

      // If startDate and endDate are provided, use date range search
      if (startDate && endDate) {
        url += `&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`;
        console.log("Using date range search:", { startDate, endDate, url });
      } 
      // Otherwise use regular search parameters
      else {
        if (search) {
          url += `&search=${encodeURIComponent(search)}`;
        }
        
        if (date) {
          url += `&date=${encodeURIComponent(date)}`;
        }
      }

      console.log("Fetching waitlist with URL:", url);
      const response = await axios.get(url);
      console.log("Waitlist response:", response.data);
      return response.data.data;
    } catch (error) {
      console.log(error,"Error")
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch waitlist entries"
      );
    }
  }
);

/**
 * Create a new waitlist entry
 */
export const createWaitlistEntry = createAsyncThunk(
  "waitlist/create",
  async (email, { rejectWithValue }) => {
    try {
      const response = await axios.post(API_URL, { email });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to create waitlist entry"
      );
    }
  }
);

/**
 * Delete a waitlist entry
 */
export const deleteWaitlistEntry = createAsyncThunk(
  "waitlist/delete",
  async (id, { rejectWithValue }) => {
    try {
      await axios.delete(`${API_URL}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete waitlist entry"
      );
    }
  }
);
